import { combineLatest, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { useObservable } from './rxjs';
export function useLocalVideoControllerState(localVideoController) {
    const localVideoControllerState = localVideoController.pipe(switchMap(controller => !controller
        ? of({
            enabled: false,
            connected: false,
            started: false,
        })
        : combineLatest([
            controller.enabled,
            controller.connected,
            controller.started,
        ]).pipe(map(([enabled, connected, started]) => ({ enabled, connected, started })))));
    return useObservable(localVideoControllerState);
}
//# sourceMappingURL=use_local_video_controller_state.js.map